// 配置API接口地址
var root = process.env.API_ROOT;
// 引用axios
import axios from "axios";
import md5 from "js-md5";
// var axios = require('axios')
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
function getServerDate() {
  var xhr = null;
  if (window.XMLHttpRequest) {
    xhr = new window.XMLHttpRequest();
  } else {
    // ie
    xhr = new ActiveObject("Microsoft");
  }

  xhr.open("GET", "/", false); //false不可变
  xhr.send(null);
  var date = xhr.getResponseHeader("Date");
  return new Date(date);
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
// axios.defaults.withCredentials = true
// 请求的拦截器
axios.interceptors.request.use(
  function(config) {
    var ts = new Date(
      $.ajax({ url: "/", type: "OPTIONS", async: false }).getResponseHeader(
        "Date"
      )
    );
    console.log('ts :>> ', ts.getTime());
    ts = ts.getTime() / 1000
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    var str = window.location.host;
    var malltype = str.split(".")[0];

    // 判断请求的类型
    // 如果是post请求就把默认参数拼到data里面
    // 如果是get请求就拼到params里面
    if (config.method === "get") {
      config.params = {
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign,
        prdfix: malltype,
        ...config.params
      };
    } else if (config.method === "post") {
      config.data = {
        ...config.data,
        timeStamp: ts,
        apiKey: apiKey,
        prdfix: malltype,
        sign: sign
      };
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method === "file" ? "POST" : method,
    url: url,
    data:
      method === "file" || method === "POST" || method === "PUT"
        ? params
        : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: root,
    withCredentials: false, //当报错为header in the response must not be the wildcard '*'时改为false
    transformRequest: [
      function(data) {
        if (method === "file") {
          return data;
        } else {
          let ret = "";
          for (let it in data) {
            ret +=
              encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        }
      }
    ],
    headers: {
      "Content-Type":
        method === "file"
          ? "multipart/form-data"
          : "application/x-www-form-urlencoded"
    }
  })
    .then(function(res) {
      success(res);
    })
    .catch(function(err) {
      // failure(err)
      // let res = err.response
      // if (err) {
      //
      // }
    });
}

// 返回在vue模板中的调用接口
export default {
  get: function(url, params, success, failure) {
    return apiAxios("GET", url, params, success, failure);
  },
  post: function(url, params, success, failure) {
    return apiAxios("POST", url, params, success, failure);
  },
  put: function(url, params, success, failure) {
    return apiAxios("PUT", url, params, success, failure);
  },
  delete: function(url, params, success, failure) {
    return apiAxios("DELETE", url, params, success, failure);
  },
  file: function(url, params, success, failure) {
    return apiAxios("file", url, params, success, failure);
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js